export default [
    {
        path: '/logout',
        name: 'logout',
        component: () => import('@/views/logout/Logout.vue'),
    },
]